import { Theme, useTheme as useMuiTheme } from '@mui/material';

// this should be the same as PaletteOptions in global.d.ts
export type AdditionalPaletteOptions = {
  black: {
    main: string;
    38: string;
  };
  primary: Theme['palette']['primary'] & {
    400: string;
    500: string;
  };
};

export type AppTheme = Theme & {
  palette: Theme['palette'] & AdditionalPaletteOptions;
};

export const useTheme = () => useMuiTheme<AppTheme>();
